import {
  targetGroupsByVirtualConstants,
  createTargetGroupsByVirtualConstants,
  editTargetGroupsByVirtualConstants,
  deleteTargetGroupsByVirtualConstants,
} from "../_redux-constants";
import { targetGroupsVirtualService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getTargetGroupsByVirtual(queryParams) {
  function getTargetGroupsByVirtualLoad() {
    return {
      type: targetGroupsByVirtualConstants.TARGET_GROUPS_BY_VIRTUAL_LOADING,
    };
  }
  function getTargetGroupsByVirtualSuccess(data) {
    return {
      type: targetGroupsByVirtualConstants.TARGET_GROUPS_BY_VIRTUAL_SUCCESS,
      data,
    };
  }
  function getTargetGroupsByVirtualFailure(error) {
    return {
      type: targetGroupsByVirtualConstants.TARGET_GROUPS_BY_VIRTUAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getTargetGroupsByVirtualLoad());
    return targetGroupsVirtualService
      .getTargetGroupsByVirtual(queryParams)
      .then(
        (data) => {
          dispatch(getTargetGroupsByVirtualSuccess(data));
        },
        (error) => {
          dispatch(getTargetGroupsByVirtualFailure(error?.toString()));
        }
      );
  };
}

function createTargetGroupsByVirtual(requestBody, queryParams) {
  function createTargetGroupsByVirtualLoad() {
    return {
      type: createTargetGroupsByVirtualConstants.CREATE_TARGET_GROUPS_BY_VIRTUAL_LOADING,
    };
  }
  function createTargetGroupsByVirtualSuccess(data) {
    return {
      type: createTargetGroupsByVirtualConstants.CREATE_TARGET_GROUPS_BY_VIRTUAL_SUCCESS,
      data,
    };
  }
  function createTargetGroupsByVirtualFailure(error) {
    return {
      type: createTargetGroupsByVirtualConstants.CREATE_TARGET_GROUPS_BY_VIRTUAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createTargetGroupsByVirtualLoad());
    return new Promise((resolve, reject) => {
      targetGroupsVirtualService
        .createTargetGroupsByVirtual(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createTargetGroupsByVirtualSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(createTargetGroupsByVirtualFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function editTargetGroupsByVirtual(requestBody, queryParams) {
  function editTargetGroupsByVirtualLoad() {
    return {
      type: editTargetGroupsByVirtualConstants.EDIT_TARGET_GROUPS_BY_VIRTUAL_LOADING,
    };
  }
  function editTargetGroupsByVirtualSuccess(data) {
    return {
      type: editTargetGroupsByVirtualConstants.EDIT_TARGET_GROUPS_BY_VIRTUAL_SUCCESS,
      data,
    };
  }
  function editTargetGroupsByVirtualFailure(error) {
    return {
      type: editTargetGroupsByVirtualConstants.EDIT_TARGET_GROUPS_BY_VIRTUAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editTargetGroupsByVirtualLoad());
    return new Promise((resolve, reject) => {
      targetGroupsVirtualService
        .editTargetGroupsByVirtual(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editTargetGroupsByVirtualSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editTargetGroupsByVirtualFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function deleteTargetGroupsByVirtual(queryParams) {
  function deleteTargetGroupsByVirtualLoad() {
    return {
      type: deleteTargetGroupsByVirtualConstants.DELETE_TARGET_GROUPS_BY_VIRTUAL_LOADING,
    };
  }
  function deleteTargetGroupsByVirtualSuccess(data) {
    return {
      type: deleteTargetGroupsByVirtualConstants.DELETE_TARGET_GROUPS_BY_VIRTUAL_SUCCESS,
      data,
    };
  }
  function deleteTargetGroupsByVirtualFailure(error) {
    return {
      type: deleteTargetGroupsByVirtualConstants.DELETE_TARGET_GROUPS_BY_VIRTUAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteTargetGroupsByVirtualLoad());
    return new Promise((resolve, reject) => {
      targetGroupsVirtualService.deleteTargetGroupsByVirtual(queryParams).then(
        (data) => {
          dispatch(deleteTargetGroupsByVirtualSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(deleteTargetGroupsByVirtualFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

export const targetGroupsByVirtualActions = {
  getTargetGroupsByVirtual,
  createTargetGroupsByVirtual,
  editTargetGroupsByVirtual,
  deleteTargetGroupsByVirtual,
};
